<template>
  <div>
    <div class="header">
      <img src="../assets/nueva.jpg" alt="Volkswagen Recall"/>
    </div>
    <div class="header-title">
      <div class="container">
        <h1>Volkswagen Recall</h1>
      </div>
    </div>
    <div id="atencion">
      <h1>Llamado a la seguridad</h1>
      <p>Si tenés un Volkswagen de los años 2006 a 2018, chequeá si es parte de la campaña de recall de airbags.</p>
      <p>Realizá sin costo la verificación en nuestros concesionarios oficiales y te bonificamos un cambio de aceite y filtro.</p>
      <p>Nuestra prioridad siempre va a ser cuidarte.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["titulo"]
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_vw-tokens.scss";

.header {
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }
}

.header-title {
  background: $vw-bg;
  padding: $vw-space-400 0 $vw-space-450;

  h1 {
    margin: 0;
    color: $vw-content;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 3.4em;
    letter-spacing: -0.01em;
    @media (max-width: 767px) {
      font-size: 2.5em;
    }
  }
}

#atencion {
  padding: 2em 0 3.4em;
  text-align: center;
  color: $vw-on-dark;
  background: $vw-gradient-radial;
  margin-bottom: 4em;

  h2 {
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  p {
    font-weight: 300;
    font-size: 1.2em;
  }
}
</style>
